export default from './post-edit-page-header';



// WEBPACK FOOTER //
// ./app/containers/post-edit-page-header/index.js